import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
export class FormFieldResource extends BaseResource {
    pk() {
        return this.availableFormFieldId?.toString();
    }
    static create() {
        return super.create().extend({
            schema: [this]
        });
    }
}
FormFieldResource.urlRoot = apiResourceUrl("formfield");
//# sourceMappingURL=FormFieldResource.js.map